import { render } from "./LocationCard.vue?vue&type=template&id=2bb586b1&scoped=true&ts=true&lang=pug"
import script from "./LocationCard.vue?vue&type=script&lang=ts"
export * from "./LocationCard.vue?vue&type=script&lang=ts"

import "./LocationCard.vue?vue&type=style&index=0&id=2bb586b1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb586b1"]])

export default __exports__